import { Country, Language, Locale } from './routing'

export function parseLocale(locale: Locale): { language: Language; country: Country } {
  const [language, country] = locale.split('-')
  return { language: language as Language, country: country as Country }
}

export function parseLocaleCountry(locale: Locale): Country {
  return parseLocale(locale).country
}
